// extracted by mini-css-extract-plugin
export var col = "product-module--col--16e5a";
export var imgBlock = "product-module--img-block--7fe16";
export var packDesc = "product-module--pack-desc--88164";
export var product = "product-module--product--b9ec0";
export var row = "product-module--row--6da83";
export var topDesc = "product-module--top-desc--116b0";